var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarFeEfforts = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_37490_36842)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 7C9.75 7 7.5 9.25 7.5 12C7.5 14.75 9.75 17 12.5 17C15.25 17 17.5 14.75 17.5 12C17.5 9.25 15.25 7 12.5 7ZM13.5 13.85C13.25 14 12.95 13.9 12.8 13.65L12.05 12.25C12 12.15 12 12.1 12 12V9.5C12 9.2 12.2 9 12.5 9C12.8 9 13 9.2 13 9.5V11.85L13.7 13.15C13.8 13.4 13.75 13.7 13.5 13.85Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_37490_36842",
  x1: 7,
  y1: 1,
  x2: 16.5,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFC1ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0DDFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarFeEfforts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_fe_efforts.8041a2309189ccb65bd1a6c474e576f5.svg";